export const TEST_ID = 'skeletonText';
